/* eslint-disable react-hooks/rules-of-hooks */
import { Button, Modal, ModalBody, ModalFooter } from '@7shifts/sous-chef';
import { __ } from 'i18n/translate';
import { useEffect, useState } from 'react';

type Props = {
    onContinue: () => void;
    onTimeout: () => void;
    minutes: number;
};

const IdleUserTimeoutModal = ({ onContinue, onTimeout, minutes }: Props) => {
    const [countDown, setCountDown] = useState(60);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountDown((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    onTimeout();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Modal
            onClose={onContinue}
            header={__('timeoutModal.title')}
            subHeader={__('timeoutModal.subtitle')}
        >
            <ModalBody>
                {__('timeoutModal.message', {
                    minutes
                })}
            </ModalBody>
            <ModalFooter
                actions={{
                    primary: (
                        <Button onClick={onTimeout} theme="danger">
                            {__('timeoutModal.buttonLogout', {
                                countDown
                            })}
                        </Button>
                    ),
                    secondary: (
                        <Button onClick={onContinue}>
                            {__('timeoutModal.buttonKeepLogged')}
                        </Button>
                    )
                }}
            />
        </Modal>
    );
};

export default IdleUserTimeoutModal;
